export default __webpack_public_path__ + "static/media/diamond.489967c2.svg";